import "./Contact.module.css";
import TopBarMainNavigation from "@/reusable_sections/Header";
import ContactHero from "./sections/ContactHero";
import ContactForm from "./sections/ContactForm";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <TopBarMainNavigation />
      <ContactHero />
      <ContactForm />
      <Footer />
    </div>;
}